// M36 — shared date formatter. Reads the user's preferred date format
// from UserSettingsContext via the useFormatDate() hook so every date
// display in the app honors the same setting.
//
// Inputs:
//   - YYYY-MM-DD strings are anchored at local noon to avoid TZ
//     slippage (a 2026-03-13 string in UTC could otherwise render as
//     "Mar 12" in the western US).
//   - ISO timestamps with timezones (created_at, etc.) parse as-is.
//   - Date objects pass through.

import type { DateFormat } from './types';

export function formatDate(date: Date | string, format: DateFormat): string {
  const d = typeof date === 'string'
    ? new Date(date + (date.length === 10 ? 'T12:00:00' : ''))
    : date;
  switch (format) {
    case 'us_long':
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    case 'us_short':
      return d.toLocaleDateString('en-US');
    case 'iso':
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    case 'eu_long':
      return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  }
}

export const DATE_FORMAT_OPTIONS: { value: DateFormat; label: string; sample: string }[] = [
  { value: 'us_long',  label: 'US (long)',  sample: 'Mar 13, 2026' },
  { value: 'us_short', label: 'US (short)', sample: '3/13/2026' },
  { value: 'iso',      label: 'ISO',        sample: '2026-03-13' },
  { value: 'eu_long',  label: 'EU (long)',  sample: '13 Mar 2026' },
];
